// ─── Root Route ───
// Wraps the application with AuthProvider and QueryClientProvider, and mounts
// the global sonner Toaster (mutation failures — 409 conflicts especially —
// surface here via the MutationCache handler in lib/query-client.ts).

import { createRootRoute, Outlet } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { queryClient } from '../lib/query-client';
import { AuthProvider } from '../features/auth/AuthProvider';
import { useUIStore } from '../stores/ui.store';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent(): React.JSX.Element {
  // sonner accepts 'light' | 'dark' | 'system' — same values as our store.
  const theme = useUIStore((s) => s.theme);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Outlet />
      </AuthProvider>
      <Toaster theme={theme} richColors closeButton position="bottom-right" />
    </QueryClientProvider>
  );
}
